export default __webpack_public_path__ + "static/media/soft7.75a56bff.jpg";